export enum AllowedStepPerformer {
    patient = 'patient',
    patientCareProvider = 'patientCareProvider',
    processRequester = 'processRequester',
    processStarter = 'processStarter',
}
